export const BRAND = {
    BASE_PATH: '/product/brand/',
    GET_ALL: '/brand',
    CREATE: '/brand/create',
    UPDATE: '/brand/update/',
    DELETE: '/brand/delete/',
    ADD_NEW_TITLE: 'Add New Brand',
};
